export default "__VITE_ASSET__e195d8a2__"